<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/159o7s5/tc-custom/9781936932535.jpg?1737164547435" alt="This image is the cover for the book Confessions of Madame Psyche"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confessions of Madame Psyche
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Describes a life that explores, in ways that only fine fiction can, the differences between myth and illusion, between real psychic gifts and false ones.”—<i>The</i></b><b><i> Denver Post</i></b></p><p>This American Book Award Winner follows the story of the young Mei-li Murrow who is dubbed “Madame Psyche” after she accidentally predicts the San Francisco earthquake of 1906. Although she wins fame and fortune, Mei-li seeks a truer spirituality, and embarks on a pilgrimage that takes her to the death-soaked Europe of the First World War, to a utopian commune in the Santa Cruz Mountains in the 1920s, to the Depression-era migrant work camps and cannery strikes, and finally to the Napa State Hospital, where she finds wisdom and peace among the outcasts of the asylum.<br/><br/> Mei-li’s modern-day epic is grounded in the history of Northern California in the first half of the twentieth century and peopled by comrades of many classes and cultures and by lovers both male and female. Yet her central odyssey remains one of inner discovery.<br/><br/> In <i>Confessions of Madame Psyche</i>, Dorothy Bryant has created a character who is so honest in her search for truth, growth, and spiritual understanding that this quest becomes inherent to her survival.</p><p>“Breathtaking and heartbreaking . . . It is in the specifics of time and place that Bryant roots the book’s magic. It is in her characterizations that the magic convinces . . . A beautiful story has, very simply, told itself.”—<i>The </i><i>Denver Post</i></p> “Fascinating and beautiful.”—Ursula K. LeGuin<br/><br/> “Intricate, appealing [and] profound.”—<i>Women’s Review of Books</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Bryant, J.J Wilson
      </h2>
      
      <p class="authorDescription body article">DOROTHY BRYANT is the author of twelve novels including The Kin of Ata Are Waiting for You, Ella Price’s Journal, and Miss Giardino. J. J. WILSON is a professor of English at Sonoma State University in California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press at CUNY
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5739d9c3